import Link from "next/link";
import { DownOutlined } from "@ant-design/icons";
import { publicFaqs } from "./publicSiteContent";
import styles from "./PublicSite.module.scss";

export default function FaqList({ items = publicFaqs, headingLevel = 2 }) {
  const Heading = `h${headingLevel}`;
  return <div>
    {items.map((item, index) => <details key={item.id} id={item.id} className={styles.question} open={index === 0}>
      <summary><Heading className={styles.questionTitle}>{item.question}</Heading><DownOutlined aria-hidden="true" /></summary>
      <div className={styles.answer}>
        {item.paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
        {item.links?.length ? <div className={styles.answerLinks}>{item.links.map(link => <Link key={link.href} href={link.href} prefetch={false}>{link.label}</Link>)}</div> : null}
      </div>
    </details>)}
  </div>;
}
